/* SnackShark only: reads published collection data; never writes stock or cart. */
(() => {
  const types = ['Candy', 'Chips & Knabberartikel', 'Gebäck & Snacks', 'Getränke', 'Schokolade & Kekse'];
  const aliases = {'Getränke & Energy Drinks':'Getränke', 'Getränke & Eistee':'Getränke', 'Fruchtgummi':'Candy', 'Süßigkeiten':'Candy', 'Cookies & Gebäck':'Schokolade & Kekse'};
  const categoryOf = product => aliases[product.type] || product.type;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('de').replace(/ß/g, 'ss');
  function selectProducts(products, state) {
    const words = normalize(state.q).trim().split(/\s+/).filter(Boolean);
    return products.filter(product => {
      if (state.category === 'other' ? types.includes(categoryOf(product)) : state.category && categoryOf(product) !== state.category) return false;
      if (state.brand && product.vendor !== state.brand) return false;
      if (state.available && !product.available) return false;
      const text = normalize([product.title, product.vendor, product.type].join(' '));
      return words.every(word => text.includes(word));
    }).sort((a, b) => state.sort === 'title' ? a.title.localeCompare(b.title, 'de') : Number(b.available) - Number(a.available));
  }
  if (typeof module === 'object') module.exports = { types, normalize, selectProducts };
  if (typeof document === 'undefined') return;
  document.querySelectorAll('[data-snack-shop]').forEach(async root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const get = selector => root.querySelector(selector);
    const form = get('form'), query = form.elements.q, brand = get('[data-shop-brand]');
    const sort = get('[data-shop-sort]'), available = get('[data-shop-available]');
    const results = get('[data-shop-results]'), status = get('[data-shop-status]'), more = get('[data-shop-more]');
    const controls = get('[data-shop-controls]'), fallback = get('[data-shop-fallback]');
    let products = [], visible = 24, category = '', loaded = false;
    function node(tag, className, text) {
      const el = document.createElement(tag);
      if (className) el.className = className;
      if (text != null) el.textContent = text;
      return el;
    }
    function state() { return {q:query.value, category, brand:brand.value, available:available.checked, sort:sort.value}; }
    function restore() {
      const params = new URL(location.href).searchParams;
      query.value = params.get('q') || '';
      category = params.get('category') || '';
      if (![...types, 'other', ''].includes(category)) category = '';
      brand.value = params.get('brand') || '';
      available.checked = params.get('available') === '1';
      sort.value = params.get('sort') === 'title' ? 'title' : 'recommended';
    }
    function render(updateUrl = true) {
      if (!loaded) return;
      const current = state(), found = selectProducts(products, current);
      get('[data-shop-categories]').querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
      status.textContent = found.length ? `${found.length} ${found.length === 1 ? 'Produkt' : 'Produkte'} · ${Math.min(visible, found.length)} angezeigt` : 'Keine passenden Produkte. Ändere die Suche oder setze die Filter zurück.';
      const fragment = document.createDocumentFragment();
      found.slice(0, visible).forEach(product => {
        const card = node('article', 'ss3-product'), art = node('div', 'ss3-product-image');
        const link = node('a'); link.href = product.url; link.setAttribute('aria-label', product.title);
        if (product.image) {
          const img = node('img'); img.src = product.image; img.alt = product.title; img.width = 540; img.height = 540; img.loading = 'lazy';
          link.append(img);
        } else link.textContent = product.title;
        art.append(link);
        if (!product.available) art.append(node('span', 'ss3-product-badge', 'Ausverkauft'));
        const copy = node('div', 'ss3-product-copy'), title = node('h2', 'ss3-product-title'), titleLink = node('a', '', product.title);
        titleLink.href = product.url; title.append(titleLink);
        copy.append(node('p', 'ss3-product-vendor', product.vendor), title);
        if (product.mhd) copy.append(node('p', 'ss-product-mhd', product.mhd));
        copy.append(node('p', 'ss3-price', (product.varies ? 'Ab ' : '') + product.price));
        copy.append(node('p', 'ss3-unit-price', product.unit || ''));
        const tax = get('[data-shop-tax]').cloneNode(true); tax.removeAttribute('data-shop-tax'); tax.className = 'ss3-tax'; copy.append(tax);
        const actions = node('div', 'ss3-product-actions'), details = node('a', 'ss3-product-buy', product.available ? 'Produkt ansehen ↗' : 'Details ansehen ↗');
        details.href = product.url; actions.append(details); copy.append(actions); card.append(art, copy); fragment.append(card);
      });
      results.replaceChildren(fragment); results.hidden = false; fallback.hidden = true;
      more.hidden = found.length <= visible;
      if (updateUrl) {
        const url = new URL(location.href);
        ['q', 'category', 'brand', 'available', 'sort', 'page'].forEach(key => url.searchParams.delete(key));
        url.searchParams.set('view', 'snackshop');
        if (current.q) url.searchParams.set('q', current.q);
        if (category) url.searchParams.set('category', category);
        if (current.brand) url.searchParams.set('brand', current.brand);
        if (current.available) url.searchParams.set('available', '1');
        if (current.sort === 'title') url.searchParams.set('sort', 'title');
        history.replaceState(null, '', url);
      }
    }
    const change = () => { visible = 24; render(); };
    form.addEventListener('submit', event => { event.preventDefault(); change(); });
    query.addEventListener('input', change); brand.addEventListener('change', change); sort.addEventListener('change', change); available.addEventListener('change', change);
    get('[data-shop-categories]').addEventListener('click', event => { const button = event.target.closest('[data-category]'); if (button) { category = button.dataset.category; change(); } });
    get('[data-shop-reset]').addEventListener('click', () => { query.value = ''; category = ''; brand.value = ''; sort.value = 'recommended'; available.checked = false; change(); });
    more.addEventListener('click', () => { visible += 24; render(false); });
    window.addEventListener('popstate', () => { restore(); change(); });
    try {
      async function page(number) {
        const url = new URL(root.dataset.collectionUrl, location.origin);
        url.searchParams.set('view', 'ss-search-data'); url.searchParams.set('page', number);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, {headers:{Accept:'text/html'}, signal:AbortSignal.timeout(20000)});
        if (!response.ok) throw Error('Collection unavailable');
        const data = await response.json();
        if (!Array.isArray(data.products)) throw Error('Invalid collection');
        return data;
      }
      status.textContent = 'Suche und Kategorien werden vorbereitet …';
      const first = await page(1);
      const pages = Math.max(1, Number(first.pages) || 1);
      // Load subsequent pages together, not sequentially. Existing cards remain visible.
      const rest = await Promise.all(Array.from({length:pages - 1}, (_, i) => page(i + 2)));
      const seen = new Set();
      products = [first, ...rest].flatMap(data => data.products).filter(product => { if (seen.has(product.id)) return false; seen.add(product.id); return true; });
      [...new Set(products.map(product => product.vendor).filter(Boolean))].sort((a,b) => a.localeCompare(b,'de')).forEach(value => { const option = node('option','',value); option.value = value; brand.append(option); });
      restore(); loaded = true; controls.hidden = false; render(false);
    } catch (_) {
      status.textContent = 'Die Filter sind gerade nicht erreichbar. Du kannst alle Produkte unten durchblättern.';
      fallback.hidden = false;
    }
  });
})();
